import { Button } from "antd";
import Modal from "antd/lib/modal/Modal";
import React from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { resetStatus, selectAuth } from "../../redux/reducers/slice/auth";

const ResendOTPModal = (props: any) => {
  const auth = useSelector(selectAuth);
  const dispatch = useDispatch();
  const { t } = useTranslation();

  return (
    <Modal
      title={t("title_modal_notification")}
      visible={props.visible}
      onCancel={async () => {
        props.setVisible(false);
        await dispatch(await resetStatus());
      }}
      footer={[
        <Button
          type="primary"
          onClick={async () => {
            props.setVisible(false);
            await dispatch(await resetStatus());
          }}>
          {t("btn_confirm")}
        </Button>,
      ]}>
      <span>
        {auth.status !== 200
          ? auth.message
          : t("auth_confirm_otp_resend_success").replace(
              "[phone_number]",
              props.phoneNumber
            )}
      </span>
    </Modal>
  );
};

export default ResendOTPModal;
